<template>
  <div class="scroll-div scroll-div-device status_page">
    <div class="col-md-12 chart-title" v-if="statusApiCallDone">
      <span>Number of registrations by status</span>
    </div>
    <div
      class="col-xs-12 col-sm-12 col-md-12 horizontal_legend"
      id="legend2"
      v-if="statusApiCallDone"
    >
      <span class="key_dot legend_active"></span>
      <span class="legend_name">Active</span>
      <span class="key_dot legend_pending"></span>
      <span class="legend_name">Pending</span>
      <span class="key_dot legend_expsoon"></span>
      <span class="legend_name">Expiring soon</span>
      <span class="key_dot legend_expired"></span>
      <span class="legend_name">Expired</span>
    </div>
    <div class="col-md-12 pie-chart" id="pieDiv"></div>
    <loader :loadingStatus="loaderStatus"></loader>
  </div>
</template>

<script>
import * as d3 from 'd3v4';
import Loader from '../UIComponents/Loader.vue';
import { getCharts } from '../../apis/reports';

export default {
  components: {
    Loader,
  },
  data() {
    return {
      mode: 'reports',
      importPercentage: 0,
      statusApiCallDone: false,
      errors: [],
      registrationdata: [],
      data: [
        { status: 'Active', count: 0 },
        { status: 'Pending', count: 0 },
        { status: 'Expiring soon', count: 0 },
        { status: 'Expired', count: 0 },
      ],
      loaderStatus: false,
    };
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.drawPieChart);
    socket.removeAllListeners(
      `alertGetChartsEvent_${localStorage.getItem('userId')}`,
    );
  },
  methods: {
    updateImportProgressStatus() {
      this.loaderStatus = false;
      this.importPercentage = 0;
    },
    async loadPieChart() {
      this.loaderStatus = true;
      this.registrationdata = [];
      this.registrationdata = await getCharts();
      this.registrationdata.forEach((curData) => {
        for (let i = 0; i < this.data.length; i += 1) {
          if (curData.status.toLowerCase() === this.data[i].status.toLowerCase()) {
            this.data[i].count += 1;
            break;
          }
        }
      });
      this.statusApiCallDone = true;
      this.drawPieChart();
    },

    drawPieChart() {
      const color = d3
        .scaleOrdinal()
        .range(['#013a68', '#4f90c3', '#ffaa49', '#ff0606']);
      const legendRectSize = 9;
      const legendSpacing = 3;

      d3.select('#pieDiv')
        .append('div')
        .attr('class', 'toolTip');
      const parentWidth = this.$el.clientWidth || 300;

      const margin = {
        top: 10,
        right: 20,
        bottom: 10,
        left: 20,
      };
      const width = parentWidth / 1.5 - margin.right - margin.left;
      const height = 300 - margin.top - margin.bottom;
      const radius = Math.min(width, height) / 2;
      const arc = d3.arc()
        .outerRadius(radius)
        .innerRadius(0);
      d3.arc()
        .outerRadius(radius - 20)
        .innerRadius(radius - 20);
      const pie = d3
        .pie()
        .sort(null)
        .value((d) => d.count);

      const svg = d3
        .select('#pieDiv')
        .append('svg')
        .attr('id', 'pieChart')
        .attr('width', '100%')
        .attr('height', '100%')
        .attr('viewBox', () => {
          if (window.screen.width >= 768) {
            return '0 0 600 450';
          }
          if (window.screen.width < 768) {
            return '0 0 300 300';
          }
          return '';
        })
        .attr('preserveAspectRatio', 'xMinYMin')
        .append('g')
        .attr(
          'transform',
          `translate(${Math.min(width, height) / 1.35},${Math.min(
            width,
            height,
          ) / 1.35})`,
        );
      const g = svg
        .selectAll('.arc')
        .data(pie(this.data))
        .enter()
        .append('g')
        .attr('class', 'arc');

      // append ticks to the arc
      const ticks = svg
        .selectAll('line')
        .data(pie(this.data))
        .enter()
        .append('line');
      ticks
        .attr('x1', 0)
        .attr('x2', 0)
        .attr('y1', -radius + 4 - 4)
        .attr('y2', -radius - 2 - 6)
        .attr('stroke', (d) => {
          if (d.data.count > 0) {
            return 'gray';
          }
          return '#ffffff';
        })
        .attr(
          'transform',
          (d) => `rotate(${((d.startAngle + d.endAngle) / 2) * (180 / Math.PI)})`,
        );
      g
        .append('path')
        .attr('d', arc)
        .attr('data-legend', (d) => d.data.status)
        .style('fill', (d) => color(d.data.status));
      g.append('text')
        .attr('transform', (d) => {
          const dist = radius + 18;
          const winkel = (d.startAngle + d.endAngle) / 2;
          const x = dist * Math.sin(winkel);
          const y = -dist * Math.cos(winkel);
          return `translate(${x},${y + 1})`;
        })

        .attr('text-anchor', 'middle')
        .style('font-family', 'roboto')
        .style('font-size', '14px')
        .style('font-weight', '400')
        .attr('fill', (d) => color(d.data.status))
        .text((d) => (d.data.count > 0 ? d.data.count : ''));

      const legend = svg
        .selectAll('.legend')
        .data(color.domain())
        .enter()
        .append('g')
        .attr('class', 'legend_svg')
        .attr('transform', (d, i) => {
          const hei = legendRectSize + legendSpacing;
          const offset = hei * color.domain().length;
          let horz = width / 4.5;
          if (window.innerWidth > 1024 && window.innerWidth < 1200) {
            horz = width / 3.5;
          }
          const vert = 1.5 * i * hei - offset * 2.5;
          return `translate(${horz},${vert})`;
        });

      legend
        .append('rect')
        .attr('width', legendRectSize)
        .attr('height', legendRectSize)
        .style('fill', color)
        .style('stroke', color);

      legend
        .append('text')
        .style('font-size', '14px')
        // .style('font-weight', '500')
        .attr('fill', '#2185D0')
        .attr('x', legendRectSize + legendSpacing + 4)
        .attr('y', legendRectSize - legendSpacing + 4)
        .text((d) => d);

      this.loaderStatus = false;
    },
  },
  created() {
    socket.on(`alertGetChartsEvent_${localStorage.getItem('userId')}`, (data) => {
      this.importPercentage = data;
    });
    window.addEventListener('resize', this.drawPieChart);
  },
  async mounted() {
    await this.loadPieChart();
  },
};
</script>
<style scoped>
@media (min-width: 1025px) {
  .pie-chart {
    width: 40%;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .pie-chart {
    width: 70%;
  }
}
@media (max-width: 767px) {
  .horizontal_legend {
    margin-left: 0px;
    padding-top: 0px;
    width: 103%;
  }
}
.status_page .horizontal_legend{
  text-align: left;
}
</style>
